import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChallengeObjective } from '../../challenge-card/objective';
function MavDetailsCard({
  challenge
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    paddingX: 4,
    paddingY: 5
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      borderBottom: '1px solid #DDE0E7',
      color: '#2c2e30',
      fontSize: 16,
      lineHeight: 1.6,
      paddingBottom: 2,
      whiteSpace: 'pre-line'
    }
  }, t('commons.challenges.mav_faq.description')), /*#__PURE__*/React.createElement(ChallengeObjective, {
    challenge: challenge
  }));
}
export default MavDetailsCard;